import { Input, Label, cn } from "@tellescope/ui";
import type { ResolvedFieldConfig } from "../../hooks/useProfileEdit";

interface ProfileFieldInputProps {
  field: ResolvedFieldConfig;
  onChange: (value: string) => void;
}

const getInputType = (key: ResolvedFieldConfig["key"]) => {
  if (key === "email") return "email";
  if (key === "phone") return "tel";
  return "text";
};

const getAutocomplete = (key: ResolvedFieldConfig["key"]) => {
  switch (key) {
    case "fname":
      return "given-name";
    case "lname":
      return "family-name";
    case "email":
      return "email";
    case "phone":
      return "tel";
    case "addressLineOne":
      return "address-line1";
    case "addressLineTwo":
      return "address-line2";
    case "city":
      return "address-level2";
    case "state":
      return "address-level1";
    case "zipCode":
      return "postal-code";
    default:
      return undefined;
  }
};

export const ProfileFieldInput = ({ field, onChange }: ProfileFieldInputProps) => (
  <div className="space-y-2">
    <Label htmlFor={field.key} className="text-sm font-medium">
      {field.label}
      {field.required && <span className="text-destructive ml-1">*</span>}
    </Label>
    <Input
      id={field.key}
      type={getInputType(field.key)}
      autoComplete={getAutocomplete(field.key)}
      value={field.value}
      onChange={(e) => onChange(e.target.value)}
      disabled={!field.editable}
      className={cn(!field.editable && "bg-muted cursor-not-allowed")}
      aria-required={field.required}
    />
  </div>
);
